import React from "react";
import style from "./style.module.scss";
import { CardDetails } from "../../common/components/CardDetails/CardDetails";
import { Image } from "antd";

type PropsType = {
  initialValue?: any;
};
export const LevageHistoryDetails = ({ initialValue }: PropsType) => {
  return (
    <div>
      <CardDetails className="d-flex gap-2 flex-column">
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Référence : </span>
          <span className={style.details__value}>
            {" "}
            {initialValue?.material?.reference}{" "}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Opération : </span>
          <span className={style.details__value}>
            {" "}
            {initialValue?.operation?.reference}{" "}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Type de mouvement : </span>
          <span className={style.details__value}>
            {initialValue?.movementType?.name}{" "}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Quantité : </span>
          <span className={style.details__value}>
            {initialValue?.quantityTxt}{" "}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Fait par : </span>
          <span className={style.details__value}>
            {" "}
            {initialValue?.checkedBy?.fullname}{" "}
          </span>
        </div>
        <div className={style.details__item}>
          <span className={style.details__subtitle}>Date: </span>
          <span className={style.details__value}>
            {" "}
            {initialValue?.createdAt}{" "}
          </span>
        </div>
        <div className="">
          <div className={style.details__item}>
            <span className={style.details__subtitle}>Commentaire :</span>
          </div>
          <div className=" px-4 py-2 ">
            <span className={`${style.details__value}`}>
              {" "}
              {initialValue?.comment}{" "}
            </span>
          </div>
        </div>
      </CardDetails>

      <div className="m-2 p-1 border rounded">
        <div className={style.details__item}>
          <span className={`${style.details__subtitle} pb-2`}>Image(s) </span>
        </div>
        <Image.PreviewGroup
          preview={{
            onChange: (current, prev) =>
              console.log(`current index: ${current}, prev index: ${prev}`),
          }}
        >
          <div className={style.details__image_wrapper}>
            {initialValue?.images?.map((img: any, index: number) => (
              <Image
                key={index}
                style={{
                  height: "200px",
                  width: "250px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  border: "solid #f4f4f4 1px",
                }}
                src={`${img.contentUrl}`}
              />
            ))}
          </div>
        </Image.PreviewGroup>
      </div>
    </div>
  );
};
